import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/search.svg'
import _imports_2 from '@/assets/img/chat/chat_on.svg'
import _imports_3 from '@/assets/img/chat/chat_off.svg'
import _imports_4 from '@/assets/img/usersGroup_2.svg'
import _imports_5 from '@/assets/img/usersGroup_2_off.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-10164db5")

_pushScopeId("data-v-10164db5")
const _hoisted_1 = { class: "hasHeader" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "searchContainer" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = { class: "tabContainer" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "onImage"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "offImage"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "activeBar" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "onImage"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  class: "offImage"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "activeBar" }, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "fs-14 text-center mt-3"
}
const _hoisted_14 = { class: "socialImage" }
const _hoisted_15 = { class: "socialDetails" }
const _hoisted_16 = { class: "socialName" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_conversation_vm = _resolveComponent("conversation-vm")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "ms-1 me-3 d-flex align-items-center",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_3
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createVNode("input", {
          type: "text",
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.debouncia && _ctx.debouncia(...args))),
          class: "searchInput ms-2",
          ref: "searchInput"
        }, null, 544), [
          [_directive_localizedPlaceholder, { key: 'app_chatSearchText', value: 'Chat, utenti...' }]
        ])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, {
        class: "tab",
        replace: true,
        to: "/chats/social/search/Chat"
      }, {
        default: _withId(() => [
          _hoisted_7,
          _hoisted_8,
          _createVNode(_component_localized_text, {
            localizedKey: "app_chats",
            text: "Chats",
            class: "tabLabel"
          }),
          _hoisted_9
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "tab",
        replace: true,
        to: "/chats/social/search/Utenti"
      }, {
        default: _withId(() => [
          _hoisted_10,
          _hoisted_11,
          _createVNode(_component_localized_text, {
            localizedKey: "app_utenti",
            text: "Utenti",
            class: "tabLabel"
          }),
          _hoisted_12
        ]),
        _: 1
      })
    ]),
    (_ctx.$route.params.tab == 'Chat')
      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.chats, (item, i) => {
          return (_openBlock(), _createBlock(_component_conversation_vm, {
            item: item,
            key: i,
            onClick: ($event: any) => (_ctx.openChat(item))
          }, null, 8, ["item", "onClick"]))
        }), 128))
      : (_ctx.$route.params.tab == 'Utenti')
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
              : (_ctx.users.length == 0)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode(_component_localized_text, {
                      localizedKey: 'app_nessunutentetrovato',
                      text: 'Nessun utente trovato'
                    })
                  ]))
                : (_ctx.users.length > 0)
                  ? (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.users, (item, i) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "socialRow",
                        key: i,
                        onClick: ($event: any) => (_ctx.openProfile(item))
                      }, [
                        _withDirectives(_createVNode("div", _hoisted_14, null, 512), [
                          [_directive_userimage, _ctx.$store.state.getUserImage(item.identifier)]
                        ]),
                        _createVNode("div", _hoisted_15, [
                          _createVNode("div", _hoisted_16, _toDisplayString(item.name), 1)
                        ])
                      ], 8, ["onClick"]))
                    }), 128))
                  : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
  ]))
})